import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '@/common/components/Label/Label';
import { LabeledValue } from '@/common/components/LabeledValue/LabeledValue';
import { ProfileCard } from '@/common/containers/Dashboard/Profile/components/ProfileCard/ProfileCard';
import { IEmployee } from '@/common/integrations/menhir/employee/employee/employee.types';
import { StringUtils } from '@/common/utils/string';
import { ContactsFormModal } from './ContactsFormModal/ContactsFormModal';

export type TContactsCardProps = {
  employee: IEmployee;
};

export function ContactsCard({ employee }: TContactsCardProps) {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <ProfileCard
        title={t('dashboard.personal_info.sections.contacts.title')}
        onEdit={() => setIsEditing(true)}
      >
        <LabeledValue
          label={t(
            'dashboard.personal_info.sections.personal.labels.company_email'
          )}
          value={
            <Label bold className="break-all">
              {employee.email}
            </Label>
          }
        />
        {employee.phone && (
          <LabeledValue
            label={t(
              'dashboard.personal_info.sections.contacts.labels.phone_number'
            )}
            value={StringUtils.formatPhoneNumber(employee.phone)}
          />
        )}
      </ProfileCard>
      {isEditing && (
        <ContactsFormModal
          employee={employee}
          onClose={() => setIsEditing(false)}
        />
      )}
    </>
  );
}
